import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PastExpoViewLayer from "../components/PastExpoViewLayer";

const PastExpoViewPage = () => {
    return (
        <MasterLayout>
            <PastExpoViewLayer />
        </MasterLayout>
    );
};

export default PastExpoViewPage;
